import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { toMoment } from 'utils/toMoment'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { ConcreteMixDesign } from '../MixDesignsContext/types'
import { useConcreteMixDesignsContext } from '../MixDesignsContext'
import { FieldValues } from '../components/Fields/types'
import { Row } from 'antd'
import {
  AggregateFields,
  OptionalFields,
  RequiredFields,
} from '../components/Fields'
import CustomFieldEditor from 'components/CustomFields/CustomFieldEditor'

export function useEdit(): EditRowActionOptions<
  ConcreteMixDesign,
  FieldValues
> {
  const { refetch, edit } = useConcreteMixDesignsContext()
  const { toMutateCustomFieldsInput, toCustomFieldEditorValue } =
    useProjectCustomFieldsContext()

  return {
    permission: [Permission.EditConcreteMixDesign],
    hidden: ({ active }) => !active,
    modal: {
      body: () => (
        <>
          <Row gutter={30}>
            <RequiredFields />
            <OptionalFields />
            <AggregateFields />
          </Row>
          <CustomFieldEditor alreadyDisabled={false} hideBooleans />
        </>
      ),
      initialValues: ({
        aggregates,
        expirationDate,
        slumpLowInches,
        slumpHighInches,
        airLow,
        airHigh,
        customFields,
        ...record
      }) => ({
        ...record,
        aggregates:
          aggregates.length < 2
            ? [aggregates[0] ?? '', aggregates[1] ?? '']
            : aggregates,
        expirationDate: toMoment(expirationDate),
        slump: {
          min: slumpLowInches,
          max: slumpHighInches,
        },
        air: {
          min: airLow,
          max: airHigh,
        },
        customFields: toCustomFieldEditorValue(customFields),
      }),
      recordName: 'mixDesignNumber',
      onOk: async (
        { globalId },
        { slump, air, customFields, expirationDate, ...input }
      ) => {
        await edit({
          variables: {
            input: {
              ...input,
              globalId,
              slumpLowInches: slump.min,
              slumpHighInches: slump.max,
              airLow: air.min,
              airHigh: air.max,
              expirationDate: expirationDate?.toISOString(),
              customFields: toMutateCustomFieldsInput(customFields),
            },
          },
        })
        refetch()
      },
    },
  }
}
